import { $settings } from '@/provider/settings';
import {
  setProfile,
  getProfileFromToken,
  setToken,
  redirect,
  clearAuth,
} from '@/services/auth/utils/authUtils';
import localStorageHelper from '@/helper/localStorageHelper';

const routes = [
  {
    path: '',
    meta: {
      public: true,
    },
    component: () => import('@/layouts/FullPage'),
    children: [
      {
        path: '',
        redirect: 'login', // Redirect if no id
      },
      {
        path: 'login',
        name: 'login',
        beforeEnter: async (to, _, next) => {
          const { token } = to.query;

          try {
            const profile = getProfileFromToken(token);

            if (profile) {
              setToken(token);
              setProfile(profile);

              const routeTo = $settings.useBasicAuth
                ? '/basicAuth'
                : redirect.value || '/dashboard/home';

              return next(routeTo);
            }
          } catch (error) {
            console.error(error);
            clearAuth();
            localStorageHelper.clearNonAuthData();
            const { default: router } = await import('@/router');
            return router.replace(''); // remove TokenId in BrowserHistory
          }
          return next();
        },
        component: () => import('@/views/public/Login'),
      },
      {
        path: 'logout',
        name: 'logout',
        component: () => import('@/views/public/Logout'),
      },
    ],
  },
];

export default routes;
